/**
 * 企業・団体カテゴリー
 */
export const EnterpriseCategory = {
  LISTED: 'listed',
  UNLISTED: 'unlisted',
  LOCAL: 'local',
  FOREIGN: 'foreign',
  VENTURE: 'venture',
  GOVERNMENT: 'government',
} as const

export type EnterpriseCategoryValue = (typeof EnterpriseCategory)[keyof typeof EnterpriseCategory]

export const EnterpriseCategoryValues = [
  { code: EnterpriseCategory.LISTED, value: '上場企業' },
  { code: EnterpriseCategory.UNLISTED, value: '未上場企業' },
  { code: EnterpriseCategory.LOCAL, value: '地方企業' },
  { code: EnterpriseCategory.FOREIGN, value: '外資系企業' },
  { code: EnterpriseCategory.VENTURE, value: 'ベンチャー企業' },
  { code: EnterpriseCategory.GOVERNMENT, value: '官公庁・団体' },
]

export const EnterpriseCategoryLabel = {
  [EnterpriseCategory.LISTED]: '上場企業',
  [EnterpriseCategory.UNLISTED]: '未上場企業',
  [EnterpriseCategory.LOCAL]: '地方企業',
  [EnterpriseCategory.FOREIGN]: '外資系企業',
  [EnterpriseCategory.VENTURE]: 'ベンチャー企業',
  [EnterpriseCategory.GOVERNMENT]: '官公庁・団体',
}
